import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, "TODOappV0", -1)
const _hoisted_4 = { class: "navbar-nav me-auto mb-2 mb-md-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, "TODOappV0", -1)
const _hoisted_9 = {
  key: 0,
  class: "navbar-nav me-auto mb-2 mb-md-0"
}
const _hoisted_10 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (!$setup.auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "navbar-brand"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }),
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Login")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/register",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Register")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "navbar-brand",
            textContent: _toDisplayString($options.getHomeText())
          }, null, 8, ["textContent"]),
          _hoisted_8,
          _createElementVNode("div", null, [
            ($setup.auth)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "nav-link",
                      onClick: $setup.logout
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Logout")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}